<template>
	<v-container fluid pa-0 v-if="!$store.getters.progress" style="padding-bottom: 10% !important">
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="flex pa-0">
					<v-toolbar flat color="grey lighten-4">
						<v-toolbar-title class="pl-3 grey--text text--darken-4">{{ editTitleDialog }}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>
					<v-container fluid px-3>
						<fields-generator
							:layoutClass="['row','wrap']" 
							:fieldsset.sync="fieldsset"
							:model="model"
							ref="fieldsgenerator"
							:selectChange="onChange"
						></fields-generator>
						<small class="px-4">* Indica i campi obbligatori</small>
					</v-container>
				</v-card>
			</v-flex>

            <v-flex xs12 pt-3 v-if="crudHasMany">
                <has-many-crud
					:title="crudHasMany.title"
                    :action-icon="crudHasMany.actionIcon"
                    :model-def='crudHasMany.modelDef'
                    :sub-filters="crudHasMany.subFilters"
					:sub-filters-id="id"
                    :action-position="crudHasMany.actionPosition"
                    :position-left="crudHasMany.positionLeft"
                    :position-right="crudHasMany.positionRight"
                    :direction="crudHasMany.direction"
					:footerComponent="crudHasMany.footerComponent"
                ></has-many-crud>
            </v-flex>


			<v-flex xs12 pt-3 v-if="crudRelation">
                <crud-table-relationship
					:title="crudRelation.title"
					:title-dialog="crudRelation.titleDialog"
					:info-relationship-url="crudRelation.infoRelationshipUrl"
					:children="relationModels"
					:key-of-model-cascade="crudRelation.keyOfModelCascade"
					:url-of-model-cascade="crudRelation.urlOfModelCascade"
					:key-of-model="crudRelation.keyOfModel"
					:default-input="crudRelation.relationDefaultInput"
					:params="{[crudRelation.params]: model[crudRelation.params]}"
					:footer-component="footerComponent"
                ></crud-table-relationship>
            </v-flex>

		</v-layout>

			<v-tooltip top>
				<v-fab-transition slot="activator">
					<v-btn
						@click.native="updateModel()"
						:loading="saved"
						color="primary"
						dark
						fixed
						bottom
						right
						fab>
						<v-icon>sync</v-icon>
					</v-btn>
				</v-fab-transition>
				<span>Aggiorna</span>
			</v-tooltip>
		</v-container>
</template>

<script>
import Vue from 'vue'
import FieldsGenerator from '@/components/FieldsGenerator'
import CrudTableRelationship from '@/components/CrudTableRelationship'
import Crud from '@/components/Crud'
import HasManyCrud from '@/components/HasManyCrud'

export default {
	name: 'edit',
	components: {
		FieldsGenerator,
		CrudTableRelationship,
		HasManyCrud
	},
	props: {
		id: Number,
		modelDef: String,
		redirect: Object,
		urlAppend: {
			type: String,
			default: ''
		},
		footerComponent: String
	},

	data() {
		return {
			fieldsset: {},
			crudRelation: null,
			crudHasMany: null,
			model: {},
			url: '',
			items: {},
			saved: false,
			relationModels: [],
			infoData: {}
		}
	},

	created() {
		this.axios.get(this.modelDef + '-info/' + this.urlAppend).then(response => {
			// get body data
			this.infoData = response.data.info

			this.initialize()
		},
		response => {
			// error callback
		})
	},

	mounted() {
		this.$eventBusUtility.$on('refreshParentModel', () => {
			this.initialize()
		})
	},

	computed: {
		editTitleDialog() {
			return 'Modifica ' + Vue.trans(this.infoData.modelTitle)
		}
	},

	methods: {
		// Call at change select option
		onChange(field, event) {
			this.$eventBusUtility.fieldsGeneratorConditions(field,
				event,
				this.fieldsset,
				this.model)
		},

		initialize() {
			let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''

			this.axios
				.get(this.modelDef + urlWithAppend + '/' + this.id + '/edit')
				.then(response => {
					// get body data
					this.fieldsset = response.data.fields
					this.crudRelation = response.data.fields.crudRelation
					this.crudHasMany = response.data.fields.crudHasMany

					if (this.crudRelation) {
						_.forEach(response.data.model[this.crudRelation.relationModelsKey],
							(value, key) => {
								let prod = value.pivot
								Vue.set(this.relationModels, key, prod)
							})
					}

					let file_key = ''
					_.forEach(this.fieldsset.fields, (value, key) => {
						if (value.type === 'checkbox' || value.type === 'file') {
							Vue.set(this.model, value.key, '')
						}
					})
					this.model = response.data.model

					this.$store.commit('endProgress')
				},
				response => {
					// error callback
				})
		},

		updateModel() {
			this.$refs.fieldsgenerator.$validator
				.validateAll()
				.then(result => {
					if (!result) {
						return false
					}
					this.saved = true
					let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''

					if (this.crudRelation) {
						this.model[
							this.crudRelation.relationModelsKey
						] = this.relationModels
					}

					this.axios
						.put(this.modelDef + urlWithAppend + '/' + this.id, this.model)
						.then(response => {
							// get body data
							this.model = {}
							this.saved = false
							// Got in show
							this.$eventBusUtility.chooseRedirect(this.$router,
								response,
								this.redirect,
								this.modelDef)
						},
						response => {
							// error callback
						})
				})
				.catch(() => {})
		}
	}
}
</script>
